// Configuration file for Lushin React App
// Values are injected at build time from .env.<CLIENT> files

export const config = {
  server: {
    websocketPort: 6329,
    deepgramPort: 6331,
    landminePort: 6332,
    competitorPort: 6333,
    calendarPort: 6335,
    trainingPort: 6340,
    standalonePort: 6345,
    frontendPort: 3000,

    websocketurl: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:6329',
    deepgramUrl: process.env.REACT_APP_DEEPGRAM_URL || 'ws://localhost:6331',
    landmineUrl: process.env.REACT_APP_LANDMINE_URL || 'ws://localhost:6332',
    competitorUrl: process.env.REACT_APP_COMPETITOR_URL || 'ws://localhost:6333',
    calendarUrl: process.env.REACT_APP_CALENDAR_URL || 'ws://localhost:6335',
    trainingUrl: process.env.REACT_APP_TRAINING_URL || 'ws://localhost:6340',
    standaloneWsUrl: process.env.REACT_APP_STANDALONE_WS_URL || 'ws://localhost:6345',
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001',
    adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL || 'http://localhost:3000',
  },
  app: {
    name: process.env.REACT_APP_NAME || 'Lushin',
    version: process.env.REACT_APP_VERSION || '0.1.0',
    logLevel: 'INFO'
  },
  // Capability flags. Build-time defaults below; the authoritative values come
  // from the backend GET /api/settings/features (and per-tenant config) at
  // runtime. Lushin runs post-call-only, so both default to false.
  // Mirrors LIVE_INTELLIGENCE_ENABLED / TRAINING_ENABLED in the services + backend.
  features: {
    liveIntelligence:
      (process.env.REACT_APP_LIVE_INTELLIGENCE_ENABLED || 'false').toLowerCase() === 'true',
    training:
      (process.env.REACT_APP_TRAINING_ENABLED || 'false').toLowerCase() === 'true',
  }
};
